import React from 'react';
import './ServicesHowWeWork.scss';
import SectionPlain from '../../components/SectionPlain';

const ServicesHowWeWork = ({ title, subTitle, cards }) => (
  <div className="how-we-work">
    <SectionPlain className="how-we-work__section" subTitle={subTitle} title={title} titleH2 />
    <div className="how-we-work__steps-container-wrapper">
      <div className="how-we-work__steps-container">
        {cards.map((card, index) => (
          <div
            key={card.title}
            className="how-we-work__step"
            data-sal="slide-up"
            data-sal-easing="ease"
            data-sal-delay={(index + 1) * 100}
          >
            <div className="how-we-work__step-bubble" />
            <h6>{card.title}</h6>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ServicesHowWeWork;
